module.exports = __webpack_public_path__ + "img/select-lang-btn-ru.5651d487.png";